import { createFileRoute } from '@tanstack/react-router'

import { GroupWorkspacePage } from '@/features/group/components/GroupWorkspacePage'
import { loadGroupWorkspace } from '@/features/group/workspaces'

export const Route = createFileRoute('/_authed/payments')({
  loader: ({ context }) => loadGroupWorkspace(context.queryClient),
  component: () => <GroupWorkspacePage mode="payments" />,
})
